import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { SectionRuleComponent } from '../section-rule/section-rule.component';

/**
 * R-FORM-01 — named section for edit forms (4+ fields). Renders the eyebrow/rule header
 * followed by a CSS-grid body. Default 2 columns; pass `columns` to override.
 *
 * Children inside `<bodyanalytics-edit-section>` can use `style="grid-column: span 2"`
 * (or the .span-full helper class) for full-width fields.
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'bodyanalytics-edit-section',
  standalone: true,
  imports: [SectionRuleComponent],
  templateUrl: './edit-section.component.html',
  styleUrls: ['./edit-section.component.scss'],
})
export class EditSectionComponent {
  readonly label = input.required<string>();
  readonly columns = input<number>(2);
}
